module.exports = __webpack_public_path__ + "img/spitter-die-1.73323039.png";